import React from 'react'

const Logo = () => {
  return (
    <div className=''>
     <h1 className='md:text-3xl text-xl text-yellow-500 font-serif font-bold'>E<span className='text-black'>lectro</span>City</h1>
    </div>
  )
}

export default Logo